import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import plansReducer from '../features/subscription/plansSlice';
import subscriptionReducer from '../features/subscription/subscriptionSlice';
import notificationsReducer from '../features/notifications/notificationsSlice';

export default configureStore({
  reducer: {
    auth: authReducer,
    plans: plansReducer,
    subscription: subscriptionReducer,
    notifications: notificationsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
